export const computeDepositRequired = (bid) => {
	if (!bid?.deposit_percent || !bid?.amount) {
		return 0;
	}
	return (Number(bid.amount) * Number(bid.deposit_percent)) / 100;
};

export const computeAdditionalDepositDue = (bid, depositPaidOnJob = 0) => {
	const required = computeDepositRequired(bid);
	if (!required) {
		return 0;
	}
	return Math.max(0, required - Number(depositPaidOnJob || 0));
};

export const computeBalanceDue = (
	bid,
	depositPaidOnJob = 0,
	refundedOnJob = 0,
) => {
	const total = Number(bid?.amount) || 0;
	const paid = Math.max(
		0,
		Number(depositPaidOnJob || 0) - Number(refundedOnJob || 0),
	);
	return Math.max(0, total - paid);
};
